import React from "react";
import ModalLayout from "src/components/shared/atoms/modalLayout";
import EmailRequiredBody from "./email";
import VerifyStatusBody from "./verify";
import useStyles from "./Styles";

interface Props {
  modalRef: any;
  onClose: any;
  modalType: string;
  changeModalType: (a: string) => void;
  userEmail: null | string;
  setIsVerifying: any;
}

const UserIncompleteInfoModal: React.FC<Props> = ({
  modalRef,
  onClose,
  modalType,
  changeModalType,
  userEmail,
  setIsVerifying,
}) => {
  const { classes } = useStyles();

  if (!modalType) return null; // render nothing if no modal type

  return (
    <ModalLayout
      headerText="User incomplete info registration"
      modalName="email-required"
      modalCustomStyle={{
        maxWidth: "600px",
        width: "100%",
      }}
      ref={modalRef}
      styleClass={classes.modalStyleClass}
      modalNotCloseUponSave
      dontCloseModalOnOutsideClick
      dontCloseModalOnCrossBtnClick
    >
      {/* <EmailRequiredBody onClose={onClose} /> */}
      {modalType === "email" && (
        <EmailRequiredBody changeModalType={changeModalType} />
      )}
      {modalType === "verify" && (
        <VerifyStatusBody
          setIsVerifying={setIsVerifying}
          userEmail={userEmail}
          onClose={onClose}
          changeModalType={changeModalType}
        />
      )}
    </ModalLayout>
  );
};

export default UserIncompleteInfoModal;
